import { GetApiV1DownloadsByIdData } from "../client/types.gen";

export type ImageFormat = NonNullable<NonNullable<GetApiV1DownloadsByIdData["query"]>["format"]>;
export type ImageResolution = NonNullable<NonNullable<GetApiV1DownloadsByIdData["query"]>["resolution"]>;

/**
 * Returns a same-origin URL for streaming a download/attachment.
 *
 * The URL is intentionally relative: `/api` is proxied to the API in every
 * environment (Traefik in production/staging, the Vite dev proxy locally),
 * and an identical string must be produced on the server and the client so
 * SSR hydration does not see mismatched `src`/`srcSet` attributes (the
 * server-side API base URL — e.g. `http://api:80` — is not reachable from a
 * browser).
 */
export function defaultStreamUrl(id: string, format?: ImageFormat, resolution?: ImageResolution) {
    const params = new URLSearchParams();
    if (format) {
        params.set("format", format);
    }
    if (resolution) {
        params.set("resolution", resolution);
    }

    const query = params.toString();
    return `/api/v1/downloads/${id}${query ? `?${query}` : ""}`;
}
